import { useStatsig } from '@atlassian/mpac-feature-flags';
import { useLocation } from '@atlassian/mpac-ui';
import { styled } from '@compiled/react';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

import {
  BlanketTransitionContainer,
  DropdownMenuTransitionContainer,
  DropdownMenuTransitionContent,
  SlidingMenuTransitionContainer,
  SlidingMenuTransitionContent,
} from './ExpandableMenu.styles';

const SpotlightDropdownContent = styled(DropdownMenuTransitionContent)({
  '&&': {
    '@media (min-width: 640px)': {
      top: '144px',
    },
  },
});

export const BlanketTransition = ({ isActive, children }) => {
  return (
    <BlanketTransitionContainer>
      <CSSTransition in={isActive} timeout={300} classNames="dropdown-menu-blanket" unmountOnExit>
        {children}
      </CSSTransition>
    </BlanketTransitionContainer>
  );
};

export const DropdownMenuTransition = ({ children, isOpen }) => {
  const { enableHomepageSpotlight } = useStatsig();
  // TODO: This is a temporary solution to check if the current page is the homepage.
  // Once the experiment is over, will remove this. Added this to avoid prop drilling for now.
  const location = useLocation();
  const pathname = location.pathname || '';
  const isHomepage = pathname === '/';

  const useSpotlightLayout = enableHomepageSpotlight() && isHomepage;

  const Content = useSpotlightLayout ? SpotlightDropdownContent : DropdownMenuTransitionContent;

  return (
    <DropdownMenuTransitionContainer>
      <CSSTransition in={isOpen} timeout={300} classNames="dropdown-menu" unmountOnExit>
        <Content>{children}</Content>
      </CSSTransition>
    </DropdownMenuTransitionContainer>
  );
};

export const SlidingMenuTransition = ({ children, isOpen }) => {
  return (
    <SlidingMenuTransitionContainer>
      <CSSTransition in={isOpen} timeout={300} classNames="sliding-menu" appear={true}>
        <SlidingMenuTransitionContent>{children}</SlidingMenuTransitionContent>
      </CSSTransition>
    </SlidingMenuTransitionContainer>
  );
};
